import { render, staticRenderFns } from "./SpecialList.vue?vue&type=template&id=27e638bc&"
import script from "./SpecialList.vue?vue&type=script&lang=ts&"
export * from "./SpecialList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports